import React, { useState } from 'react';

export default function InfoTooltip({ text, title }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        title="Click pentru informații"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '16px',
          color: '#0056b3',
          padding: '0 4px',
          verticalAlign: 'middle',
          lineHeight: 1
        }}
        aria-label="Informații"
      >
        ℹ️
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            animation: 'fadeIn 0.2s ease'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '28px 32px',
              maxWidth: '520px',
              width: '90%',
              maxHeight: '80vh',
              overflowY: 'auto',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
              position: 'relative',
              animation: 'slideUp 0.25s ease'
            }}
          >
            <button
              onClick={() => setOpen(false)}
              style={{
                position: 'absolute',
                top: '12px',
                right: '16px',
                background: 'none',
                border: 'none',
                fontSize: '22px',
                cursor: 'pointer',
                color: '#999',
                lineHeight: 1,
                padding: '4px'
              }}
              aria-label="Închide"
            >
              ✕
            </button>
            {title && (
              <h3 style={{
                margin: '0 0 12px 0',
                color: '#0056b3',
                fontSize: '18px',
                paddingRight: '30px'
              }}>
                {title}
              </h3>
            )}
            <div style={{
              fontSize: '14px',
              lineHeight: '1.7',
              color: '#444',
              whiteSpace: 'pre-line'
            }}>
              {text}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
